import { NgModule } from "@angular/core";
import { AuthGuard } from "../../util/guard/auth.guard";
import { RouterModule } from "@angular/router";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { NgSelectModule } from "@ng-select/ng-select";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { ComponentsModule } from "../../util/components/components.module";
import { NgbAlertModule, NgbNavModule, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { OfficeListComponent } from "./office-list/office-list.component";
import { OfficeModalComponent } from "./office-modal/office-modal.component";

const routes = [
  {
    path: "offices",
    component: OfficeListComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [OfficeListComponent, OfficeModalComponent],
  imports: [
    RouterModule.forChild(routes),
    ContentHeaderModule,
    CoreCommonModule,
    NgxDatatableModule,
    NgSelectModule,
    SweetAlert2Module,
    ComponentsModule,
    NgbNavModule,
    NgbAlertModule,
    NgbTooltip,
  ],
})
export class OfficesModule {}
